import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import OrganigramaAreaDataService from './services/organigramaarea.service';
import OrganigramaDataService from "./services/organigrama.service";
import CompetenciaDataService from './services/competencia.service';
import { Container, Row, Tooltip, Table, Col, FormLabel, FormControl, Button } from 'react-bootstrap';
import Sidebar from "./Sidebar";
import ExportSidebar from "./ProSideBar";
import { dtFormatter, PageHeader } from './AuxiliaryFunctions';
import { useSelector } from "react-redux";
import MessageBox from './MessageBox';
import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'
import { FaFilePdf } from "react-icons/fa";



const ListaDeJueces = () => {
  let params = useParams();
  let organigramaid = params.organigramaid;
  let competenciaid = params.competenciaid;
  let userid = params.userid; // it might not be the current user

  console.log(competenciaid);

  const { user: currentUser } = useSelector((state) => state.auth);	

  const [errmessage, setErrmessage] = useState("");
  const [showerror, setShowerror] = useState(false);
  const [succmessage, setSuccmessage] = useState("");
  const [showsuccess, setShowsuccess] = useState(false);

  const [listOfJudges, setListofJudges] = useState([]);
  const [organigrama, setOrganigrama] = useState({});
  const [competencia, setCompetencia] = useState({});

  const onExportPDF = () => {
    const doc = new jsPDF({orientation: 'landscape'});

    // 📝 Add a title
    doc.setFontSize(14);
    doc.text('Reporte de jueces asignados', 14, 12);

    // 📄 Add a subtitle or description
    doc.setFontSize(12);
    doc.text('Organigrama: ' + organigrama.nombreorganigrama, 14, 20);
    doc.text('Competencia: ' + competencia.nombrecompetencia, 14, 28);

    const headerarray = ["Categoría", "Nombre área", "Nombre Juez", "Teléfono", "Firma", "Comentarios del organizador"];
    const bodyarray = listOfJudges.map(obj => {
      return [
        obj.childcategory, 
        obj.displayName?obj.displayName:obj.nombreareaorposicion, 
        (obj.primerapellido?obj.primerapellido + " ":"") + (obj.segundoapellido?obj.segundoapellido + ", ":"") + (obj.primernombre?obj.primernombre:""), 
        obj.telefonomovil, 
        "",
        ""
      ];
    });

    console.log(bodyarray);

    // 📊 Add the table
    autoTable(doc, {
      head: [headerarray],
      body: bodyarray,
      startY: 35, // 👈 Push table below the text
    })

    // 🧾 Add footer or additional notes
    const finalY = doc.lastAutoTable.finalY;
    doc.setFontSize(10);
    doc.text('Generado fecha y hora local: ' + new Date(), 14, finalY + 10);

    doc.save('Lista de jueces.pdf')
  };  

  useEffect(() => {   
    OrganigramaDataService.get(organigramaid)
    .then(resp => {
      setOrganigrama(resp.data);
    })
    .catch(e => {
      setShowsuccess(false);
      setSuccmessage("");
      setErrmessage(e.response.data);
      setShowerror(true);
    });
    
    OrganigramaAreaDataService.getList(organigramaid, competenciaid, userid)
      .then(resp => {
        console.log(resp.data);
        setListofJudges(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e);
          setShowerror(true);
        }
      });  
    
    CompetenciaDataService.get(competenciaid)
      .then(resp => {
        setCompetencia(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e.response.data);
          setShowerror(true);
        }
      });     
     
    
  }, []);  
  
  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <Container>
        <PageHeader />  
        <Row className='mb-2 d-flex'>
          <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Lista de jueces</h5>
        </Row>          
        <Row className='mb-2 d-flex'>          
          <Col lg={4}>
            <FormLabel className='mb-2'>Nombre del organigrama:</FormLabel>       
            <FormControl type="text" name="nombreorganigrama" id="nombreorganigrama" disabled defaultValue={organigrama?organigrama.nombreorganigrama:""}></FormControl>
          </Col>
          <Col lg={4}>
            <FormLabel className='mb-2'>Descripción del organigrama:</FormLabel>       
            <FormControl type="text" name="descripcionorganigrama" id="descripcionorganigrama" disabled defaultValue={organigrama?organigrama.descripcionorganigrama:""}></FormControl>                          
          </Col>
        </Row>  

        <Row className='mb-2 d-flex'>          
          <Col lg={4}>
            <FormLabel className='mb-2'>Nombre de la competencia:</FormLabel>       
            <FormControl type="text" name="nombrecompetencia" id="nombrecompetencia" disabled defaultValue={competencia?competencia.nombrecompetencia:""}></FormControl>
          </Col>
          <Col lg={4}>
            <FormLabel className='mb-2'>Fecha de inicio:</FormLabel>       
            <FormControl 
              type="text" 
              name="fecha inicio" 
              id="fecha inicio" 
              disabled
              defaultValue={competencia?competencia.fechainicio:""}
            >
            </FormControl>                          
          </Col>
        </Row>  

        <Row className='mb-2 d-flex'>
          <Col lg={4}>
            <FormLabel style={{marginRight:'10px'}}>{"Exportar lista:"}</FormLabel>
            <Button onClick={onExportPDF}><FaFilePdf size={15} color='white'/></Button>
          </Col>          
        </Row>                
        <Row>
          <ListaJuecesOrganigrama listOfJueces={listOfJudges}/>
        </Row>

          
      </Container>
      
    </div>




    <Row className='mt-2'>

      {showerror && (
        <MessageBox show={true} showerror={showerror} errmessage={errmessage}
          onHide={() => {
            setShowerror(false)
          }}
        />
      )}
      {showsuccess && (
        <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
          onHide={() => {
          setShowsuccess(false);
          window.location.reload();
        }}
        />
      )}

    </Row>   
    </>   
  );    
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Categoría</th>
        <th style={{width:'10%'}}>Nombre área o posición</th>
        <th style={{width:'25%'}}>Juez asignado</th>
        <th style={{width:'10%'}}>Teléfono del juez</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOfJueces) {
    
    const rows = props.listOfJueces.map((row, index) => { 
      return (
        <>
        <tr key={index}>        
          <td>
            {row.childcategory}
          </td>
          <td style={{whiteSpace:'pre'}}>  
            {row.displayName?row.displayName:row.nombreareaorposicion}
          </td>
          <td>  
            {row.userId?(row.primerapellido + ", " + row.primernombre):<span style={{color:"red"}}>No se ha asignado el juez!</span>}
          </td>   
          <td>
            <a href={"sms:+" + row.telefonomovil}>
              {row.telefonomovil}
            </a>                                  
          </td>
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const ListaJuecesOrganigrama = (props) => {        
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader/>
            <TableBody listOfJueces={props.listOfJueces} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};

export default ListaDeJueces;